
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","stroke":"#000","opacity":".4","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.3 9.142c.044.692.044 1.409 0 2.1-.23 3.536-3.006 6.352-6.492 6.583-1.189.08-2.43.08-3.617 0a4.057 4.057 0 01-1.238-.282c-.427-.176-.64-.264-.75-.25-.108.013-.265.129-.58.36-.555.41-1.254.704-2.29.679-.525-.013-.787-.02-.905-.22-.117-.2.03-.476.322-1.03.405-.769.662-1.648.273-2.353-.67-1.007-1.24-2.199-1.323-3.487a16.458 16.458 0 010-2.1c.228-3.535 3.005-6.351 6.49-6.583 1.003-.066 1.21-.077 2.226-.03M7.082 12.5h5.833M7.082 8.333h2.917","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M18.333 4.583a2.917 2.917 0 11-5.833 0 2.917 2.917 0 015.833 0z","stroke-width":"1.5"}})])
          )
        }
      }
    